export default __webpack_public_path__ + "assets/images/sudoku-5ad92971d929d8faeb3a1734daf6c54c.png";